import { useState } from 'react';
import { categories } from '@/mocks/categories';

interface CategoryFilterProps {
  region: string;
  status: string;
  tag: string;
  sort: string;
  onRegion: (v: string) => void;
  onStatus: (v: string) => void;
  onTag: (v: string) => void;
  onSort: (v: string) => void;
  onReset: () => void;
}

const regions = ['全部', '韩国', '中国', '日本'];
const statuses = ['全部', '连载中', '已完结'];
const sorts = [
  { key: 'updated', label: '按更新时间' },
  { key: 'hot', label: '按热度' },
  { key: 'favorite', label: '按收藏数' },
];

function ChipGroup({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: { key: string; label: string }[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="shrink-0 text-xs text-foreground-500">{label}</span>
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          onClick={() => onChange(o.key)}
          className={`whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors cursor-pointer ${
            value === o.key
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200'
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export default function CategoryFilter(props: CategoryFilterProps) {
  const { region, status, tag, sort, onRegion, onStatus, onTag, onSort, onReset } = props;
  const [open, setOpen] = useState(false);

  const tagOptions = [
    { key: '全部', label: '全部' },
    ...categories.map((c) => ({ key: c.key, label: c.name })),
  ];

  const body = (
    <div className="space-y-4">
      <ChipGroup
        label="地区"
        options={regions.map((r) => ({ key: r, label: r }))}
        value={region}
        onChange={onRegion}
      />
      <ChipGroup label="题材" options={tagOptions} value={tag} onChange={onTag} />
      <ChipGroup
        label="状态"
        options={statuses.map((s) => ({ key: s, label: s }))}
        value={status}
        onChange={onStatus}
      />
      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-background-200/80 pt-3">
        <ChipGroup
          label="排序"
          options={sorts.map((s) => ({ key: s.key, label: s.label }))}
          value={sort}
          onChange={onSort}
        />
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600 cursor-pointer"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      </div>
    </div>
  );

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 p-4">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="mb-3 flex w-full items-center justify-between text-sm font-medium text-foreground-800 md:hidden"
      >
        <span className="flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500" />
          筛选与排序
        </span>
        <i className={open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
      </button>
      <div className={`${open ? 'block' : 'hidden'} md:block`}>{body}</div>
    </div>
  );
}